export default __webpack_public_path__ + "static/media/undraw_maintenance_re_59vn 1.51442bb5.png";